<template>
    <div class="index">
        <forms ref="formList" :list="formList" :value="formData" :rules="formRules" :btns="formBtns" labelWidth="120px"></forms>
    </div>
</template>
<script>
import api from '../../../api/workOrder'
import { regionData , CodeToText } from "element-china-area-data";
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {dispatchTypeList,caseTypeList,isHurtList} from '../../../assets/selectList/index'
export default {
    name: 'index',
    components:{
        forms
    },
    watch: {
    },
    data () {
        return {
            formData:{
                company:null,
                bankType:null,
                reportNo:null,
                dispatchType:null,
                carNo:null,
                name:null,
                tel:null,
                doParts:null,
                agency:null,
                address:null,
                caseType:null,
                isHurt:null,
                tip:null,
            },
            formList:[
                {type: "input",label: "委托主体:",name: "company",},
                {type: "select",label: "展业机构:",name: "bankType",},
                {type: "input",label: "报案号:",name: "reportNo",},
                {type: "select",label: "派工类型:",name: "dispatchType",options:dispatchTypeList},
                {type: "input",label: "车牌号:",name: "carNo",},
                {type: "input",label: "联系人:", name: "name",},
                {type: "input",label: "联系方式:",name: "tel",},
                // {type: "input",label: "承保险种:",name: "",},
                {type: "select",label: "作业机构:",name: "doParts",},
                {type: "address",label: "作业区域:",name: "agency",},
                // {type: "input",label: "作业人员:",name: "",},
                {type: "textarea",label: "作业地址:",name: "address",row:2,valueWidth:'886px'},
                {type: "select",label: "案件类型:",name: "caseType",options:caseTypeList},
                {type: "select",label: "是否含人伤:",name: "isHurt",options:isHurtList},
                {type: "textarea",label: "备注:",name: "tip",row:4,valueWidth:'886px'},
                // {type: "switch",label: "是否电话通知:",name: "",},
                // {type: "input",label: "委托主体客服电话:",name: "",},
            ],
            formRules:{
                company: [{ required: true, message: '请填写委托主体', trigger: 'blur' }],
                bankType: [{ required: true, message: '请填写展业机构', trigger: 'change' }],
                reportNo: [{ required: true, message: '请填写报案号', trigger: 'blur' }],
                dispatchType: [{ required: true, message: '请填写派工类型', trigger: 'change' }],
                carNo: [{ required: true, message: '请填写车牌号', trigger: 'blur' }],
                name: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
                tel: [{ required: true, message: '请填写联系方式', trigger: 'blur' }],
                doParts: [{ required: true, message: '请填写作业机构', trigger: 'change' }],
                agency: [{ required: true, message: '请填写作业区域', trigger: 'blur' }],
                address: [{ required: true, message: '请填写作业地址', trigger: 'blur' }],
                caseType: [{ required: true, message: '请填写案件类型', trigger: 'change' }],
                isHurt: [{ required: true, message: '请选择是否含人伤', trigger: 'change' }],
            },

            formBtns:[
                {name:'保存案件',icon:'el-icon-circle-plus',type:'success',handleClick:this.save},
                {name:'智能解析',icon:'el-icon-thumb',type:'primary',handleClick:this.analysis}
            ],
        }
    },
    created(){
        this.mechanismList();
        this.insuranceCompanyList();

    },
    mounted(){
    },
    methods:{
        async save(){
            let flag = this.$refs["formList"].validateForm();
            console.log(this.formData);
            return;
            // let res = await api.WorkOrderAdd();
        },
        analysis(){

        },
        async mechanismList(){
            let res  = await api.QueryMechanism({});
        },
        async insuranceCompanyList(){
            let res  = await api.InsuranceCompanyList({});
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .index{
        padding-top: 20px;
    }
</style>
